import { render } from "./woniuBill.vue?vue&type=template&id=1fc1c4c8&scoped=true"
import script from "./woniuBill.vue?vue&type=script&lang=js"
export * from "./woniuBill.vue?vue&type=script&lang=js"

import "./woniuBill.vue?vue&type=style&index=0&id=1fc1c4c8&scoped=true&lang=css"
import "./woniuBill.vue?vue&type=style&index=1&id=1fc1c4c8&lang=css"
script.render = render
script.__scopeId = "data-v-1fc1c4c8"

export default script